import styled from "@emotion/styled"
import { PButtonPure } from "@porsche-design-system/components-react"
import type { MessageDescriptor } from "react-intl"
import { FormattedMessage } from "react-intl"
import type { FormValidationBannerItem } from "./FormValidationBannerItem"
import { formValidationBannerMessages } from "./formValidationBanner.messages"

interface ErrorGroupProps {
	errors: FormValidationBannerItem[]
	maxDisplayError: number
	message: MessageDescriptor
}

export const ErrorGroup = ({ errors, maxDisplayError, message }: ErrorGroupProps) => (
	<Layout>
		<FormattedMessage {...message} values={{ count: errors.length }} />
		{errors.slice(0, maxDisplayError).map((error, index) => (
			<PButtonPure
				type="button"
				key={`${error.label}-${index}`}
				data-testid={`error-button-${index}`}
				onClick={error.focus}
			>
				{error.label}
			</PButtonPure>
		))}
		{errors.length > maxDisplayError && (
			<FormattedMessage
				{...formValidationBannerMessages.additionalErrors}
				values={{ count: errors.length - maxDisplayError }}
			/>
		)}
	</Layout>
)

const Layout = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
`
